<template>
  <ChatBody :domain="domain" type-call="CONFERENCE" />
  <ChatDmFooter v-if="state.isVisibleDm" />
  <ChatFooter
    v-show="!state.isVisibleDm"
    type-call="CONFERENCE"
    :domain="domain"
    :list-button-visible="footerOptions"
  />
</template>

<script setup lang="ts">
import ChatBody from '@/components/domains/chat/common/ChatBody.vue';
import ChatDmFooter from '@/components/domains/chat/common/ChatDmFooter.vue';
import ChatFooter from '@/components/domains/chat/common/ChatFooter.vue';
import { TypeDomain } from '@/types/common';
import { ChatFooterOptions, ChatFooterViewType } from '@/types/components';
import { DEFAULT_CHAT_UI_STATE, CHAT_FOOTER_PRESETS } from '@/utils/constants/chat';
import { DOMAIN } from '@/utils/constants/common';
import { ij_chat_ui } from '@/utils/injectionKeys';

withDefaults(
  defineProps<{
    code: string;
  }>(),
  {
    code: '',
  }
);

const { state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE); // provide: ChatLayout

const route = useRoute();

const domain = computed<TypeDomain>(() => {
  const metaDomain = route.meta.domain;
  return metaDomain && Object.values(DOMAIN).includes(metaDomain) ? metaDomain : 'CHAT';
});

const footerViewType = computed<ChatFooterViewType>(() => {
  if (state.isVisibleMCSPController) return 'MCSP';
  if (state.isVisibleMCSController) return 'MCS';
  return 'CONFERENCE';
});

const footerOptions = computed<ChatFooterOptions[]>(() => {
  return CHAT_FOOTER_PRESETS[footerViewType.value] || [];
});
</script>

<style lang="scss" scoped></style>
